import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider } from "./contexts/AuthContext";

// Pages
import Home from "./pages/Home";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Trainers from "./pages/Trainers";
import BookTrainer from "./pages/BookTrainer";
import MyBookings from "./pages/MyBookings";
import PaymentSuccess from "./pages/PaymentSuccess";
import Admin from "./pages/Admin";
import Credits from "./pages/Credits";
import CreditsSuccess from "./pages/CreditsSuccess";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/trainers" element={<Trainers />} />
          <Route path="/book/:trainerId" element={<BookTrainer />} />
          <Route path="/bookings" element={<MyBookings />} />
          <Route path="/payment-success" element={<PaymentSuccess />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/credits" element={<Credits />} />
          <Route path="/credits/success" element={<CreditsSuccess />} />
        </Routes>
      </BrowserRouter>
      <Toaster richColors position="top-right" />
    </AuthProvider>
  );
}

export default App;
